if (!customElements.get('mmc-restock-alert')) {
  customElements.define('mmc-restock-alert', class extends HTMLElement {
    connectedCallback() {
      this.config = JSON.parse(this.querySelector('[data-restock-config]').textContent);
      this.form = this.querySelector('form');
      this.status = this.querySelector('[role="status"]');
      this.selected = this.config.selected;
      this.change = () => {
        const value = document.getElementById(this.dataset.form)?.querySelector('[name="id"]')?.value;
        this.update(value || this.selected);
      };
      this.form.addEventListener('submit', this.submit = this.submit.bind(this));
      document.addEventListener('change', this.change);
      const variantInput = document.getElementById(this.dataset.form)?.querySelector('[name="id"]');
      if (variantInput) {
        this.observer = new MutationObserver(this.change);
        this.observer.observe(variantInput, {attributes:true,attributeFilter:['value','disabled']});
      }
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
          const id = String(event.data?.variant?.id || '');
          if (this.config.variants.some(v => v.id === id)) this.update(id);
        });
      }
      this.update(this.selected);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.unsubscribe?.();
      document.removeEventListener('change', this.change);
      this.form?.removeEventListener('submit', this.submit);
    }
    update(id) {
      const variant = this.config.variants.find(v => v.id === String(id));
      this.hidden = !variant || variant.available;
      if (this.selected !== id) {
        this.status.textContent = '';
        this.form.reset();
        this.selected = id;
      }
    }
    async submit(event) {
      event.preventDefault();
      const button = this.form.querySelector('[type="submit"]');
      const variantId = this.selected;
      button.disabled = true;
      this.status.textContent = '';
      try {
        const response = await fetch('https://diagnostic.gsm-clinique.com/stock-alert/subscribe', {
          method:'POST',credentials:'omit',signal:AbortSignal.timeout(20000),
          headers:{'Content-Type':'application/json','X-MMC-Restock':'1'},
          body:JSON.stringify({email:this.form.elements.email.value,website:this.form.elements.website.value,handle:this.config.handle,variant_id:variantId,locale:this.config.locale==='en'?'en':'fr'})
        });
        if (variantId !== this.selected) { this.status.textContent = this.config.messages.changed;return; }
        this.status.textContent = this.config.messages[response.ok?'success':response.status===409?'available':response.status===429?'rate':'error'];
        if (response.ok) this.form.reset();
      } catch {
        if (variantId === this.selected) this.status.textContent = this.config.messages.error;
      } finally { button.disabled = false; }
    }
  });
}
